import {
  ActionType,
  IDeletePatientResponse,
  IDeletePatientPayload,
} from "models/patients/deletePatient";

export const deletePatientAction = (payload: IDeletePatientPayload) => {
  return {
    type: ActionType.DELETE_PATIENT,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_PATIENT_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IDeletePatientResponse) => {
  return {
    type: ActionType.DELETE_PATIENT_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DELETE_PATIENT_RESET,
  };
};
